import { InjectionToken } from "@angular/core";
import { MasterDataPort } from "./master-data.port";

export const MASTER_DATA_PORT = new InjectionToken<MasterDataPort>(
  "MASTER_DATA_PORT",
);
